import MrtCompaniesTable from "@/components/Table/MrtCompaniesTable.tsx";
import { type NewCompany, useAddCompany } from "@/mutations/useAddCompany.tsx";
import { getErrorMessage } from "@/utils/api.ts";
import { Button, Stack, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { type ReactNode, useCallback, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const PlacesPage = (): ReactNode => {
    const navigate = useNavigate();
    const addCompanyMutation = useAddCompany();

    const doAddCompany = useCallback(() => {
        addCompanyMutation.mutate(null, {
            onSuccess: (company: NewCompany) => {
                enqueueSnackbar("Company added.", { variant: "success" });
                navigate(`/place-detail/${company.idUUID}`);
            },
            onError: (error) => {
                enqueueSnackbar("Error: Add Company failed.", { variant: "error" });
                console.info("error", getErrorMessage(error));
            },
        });
    }, [addCompanyMutation]);

    useEffect(() => {
        document.title = "Companies";
    }, []);

    return (
        <>
            <Stack
                sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                }}
            >
                <Typography variant="h4" mb={2}>
                    Companies
                </Typography>
                <Button variant={"contained"} onClick={() => doAddCompany()}>
                    Add Company
                </Button>
            </Stack>

            <MrtCompaniesTable />
            <Outlet />
        </>
    );
};

export default PlacesPage;
